<template>
  <v-card flat color="transparent">
    <v-card-text class="py-0">
      <v-row class="ma-0 pa-0" align="center" style="height: 60px;">
        <v-col cols="12" class="pa-0 b-B">
          <v-toolbar flat color="transparent" height="40">
            <v-toolbar-title class="text-left subheading">
              <span class="title">メインテナンス</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="modified" rounded depressed small @click="onRefresh()">
              <span class="px-1 text-none">中止</span>
            </v-btn>
            <v-btn v-if="modified" dark rounded depressed small color="error" class="mx-1" @click.native="dialog = true">
              <span class="text-none">実行</span>
            </v-btn>
          </v-toolbar>
        </v-col>
      </v-row>
      <v-sheet class="overflow-y-auto" :style="contentsHeight">
        <v-row class="ma-0 pa-0" align="center">
          <v-col cols="12" class="px-0">
            <v-card-text class="py-0">
              <v-row class="pa-0 ma-0" align="center">
                <v-col cols="1">
                  <!-- <v-btn color="error" @click="createActsData">メインテナンスモード（⚠️要注意）</v-btn> -->
                </v-col>
                <v-col cols="8" align="center">
                  <v-textarea
                    outlined
                    name="message"
                    label="メッセージ"
                    v-model="message"
                    prepend-inner-icon="mdi-pencil-box"
                    hideDetails
                    @change="modified = true"
                    rows=12
                  ></v-textarea>
                </v-col>
                <v-col cols="2" align="center">
                  <v-switch :label="enable ? '告知オン' : '告知オフ'" v-model="enable" class="mx-2" color="error" @change="modified = true"></v-switch>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
      </v-sheet>
    </v-card-text>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

    <div>
      <app-basic-dialog
        v-if='dialog'
        @dismissed="onDismissed"
        :title="'メインテナンス'"
        :message="'メインテナンス状態を変更します'"
        :dialog='dialog'
        :color="'error'"
        :cancel='true'>
      </app-basic-dialog>
    </div>

  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  props: [],
  computed: {
    ...mapGetters({
      maintenance: 'shared/maintenance',
      windowSize: 'shared/windowSize'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  data () {
    return {
      dialog: false,
      modified: false,
      message: null,
      enable: false,
      loading: false
    }
  },
  created () {
    if (this.maintenance) {
      this.message = this.maintenance.message
      this.enable = this.maintenance.state
    }
  },
  methods: {
    onMaintenance () {
      firebase.database().ref('/system/maintenance').set({
        state: this.enable,
        message: this.message
      }, function (error) {
        if (error) {
          console.log(error)
        } else {
          console.log('maintenance mode has been changed.')
        }
      })
    },
    onDismissed: function (value) {
      if (this.dialog) {
        this.dialog = false
        if (value) {
          this.onMaintenance()
        }
      }
    },
    onRefresh () {
      this.modified = false
    }
  }
}
</script>

<style scoped>
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

</style>
